<template>
	<el-form-item :label="title + ':'" prop="shop_info" style="margin-bottom: 0;">
		<el-checkbox size="mini" :indeterminate="isIndeterminate" v-model="checkAll" @change="selectStoreAll">全选
		</el-checkbox>
		<el-checkbox-group size="mini" v-model="storeIdsList" @change="selectStore">
			<el-checkbox v-for="store in storesData" :label="store.shop_id" :key="store.shop_id">{{store.shop_name}}</el-checkbox>
		</el-checkbox-group>
	</el-form-item>
</template>

<script>
	export default {
		data() {
			return {
				isIndeterminate: false,
				checkAll: false,
				storesData: this.$store.getters['shopList'],
				storeIdsList: this.storeIds,
			}

		},
		props: {
			title: {
				type: String,
				default: '可应用的门店'
			},
			storeIds: {
				type: Array,
			}
		},
		watch: {
			storeIdsList: {
				immediate: true,
				deep: true,
				handler(newval) {
					// console.log(oldval, '111')
					if (newval.length) {
						let result = new Array()
						let ids = newval.toString()
						for (let i = 0; i < this.storesData.length; i++) {
							if (ids.indexOf(this.storesData[i].shop_id.toString()) > -1) {
								result.push(this.storesData[i]);
							}
						}
						this.$emit('sendStore', result)
					} else {
						this.$emit('sendStore', newval)
					}
				}
			}
		},
		created() {

		},
		mounted() {
			// console.log(this.storeIds,this.$store.state.allShops.length)
			if (this.storeIds.length > 0 && this.storeIds.length == this.storesData.length) {
				this.storeIdsList = this.storeIds
				this.checkAll = true
			} else if (this.storeIds.length > 0 && this.storeIds.length != this.storesData.length) {
				this.storeIdsList = this.storeIds
				this.isIndeterminate = true
			}
		},
		methods: {
			selectStoreAll(val) {
				// 全选门店
				let data = [];
				this.storesData.map(item => {
					data.push(item.shop_id)
				})
				this.storeIdsList = val ? data : [];
				this.isIndeterminate = false;
			},
			selectStore(value) {
				//选择门店
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.storesData.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.storesData.length;
			},
		}
	}
</script>


<style>
</style>
